import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {Box, IconButton, Tooltip} from '@mui/material';
import {request_cancel_order} from 'connector/order';
import {IOrder} from 'types';

export default function CancelButton(props: {index: number; order: IOrder; is_processing: boolean; set_is_processing: (is_processing: boolean) => void}) {
	const {is_processing, set_is_processing, order} = props;

	const handleClick = async (order_id?: string) => {
		if (!order_id || is_processing) return;
		set_is_processing(true);

		request_cancel_order(order_id).then(() => {
			setTimeout(() => set_is_processing(false), 500);
		});
	};

	const is_disabled = (order.state !== 'opening' && order.state !== 'closing') || is_processing || order.archived;

	return (
		<Tooltip title={`Order ID: ${order.order_id}`} arrow placement="top">
			<Box position="relative">
				<IconButton onClick={() => handleClick(order.order_id)} disabled={is_disabled} sx={{padding: 0}}>
					<CancelOutlinedIcon sx={{fontSize: '30px'}} />
				</IconButton>
			</Box>
		</Tooltip>
	);
}
